/* IL VISORE DEL CATALOGO (giro finale, foglio 08 §2-§3, voce cat-visore, 10/10/2026). Lo carica solo
   sections/zg-catalogue-viewer.liquid (defer). Senza questo file la fila resta una riga che scorre (scroll-snap nativo).
   - L'unita' della fila: da 1024 px il foglio del PDF (una doppia pagina), sotto la pagina stampata. Ogni unita' e' larga
     quanto la fila, quindi l'unita' in vista e' round(scrollLeft / larghezza). La fila e' dir="ltr" anche in arabo.
   - Frecce, ← → Inizio Fine col fuoco nel tavolo verde; il contatore; l'indirizzo #pNN (pagina stampata) con replaceState,
     e chi apre #pNN parte da li'.
   - Le immagini: la copertina e' nel markup (eager, fetchpriority high); le altre prendono src e srcset (data-*) quando
     sono la pagina in vista o una delle due vicine, e solo dopo la copertina (la banda va prima all'LCP).
   - La rotella con Lenis (acceso al computer, luxury.js): Lenis ascolta la rotella sulla finestra e la trasforma in
     scorrimento verticale. Il meccanismo del foglio 07 da' il gesto al contenitore che scorre in quella direzione: qui per
     asse. Un gesto orizzontale sulla fila (deltaX dominante al primo evento, tenuto finche' il gesto non si ferma 200 ms; o la
     rotella con Maiuscolo, che Windows manda come deltaY) non sale alla finestra e lo scorre il browser nella fila; uno
     verticale sale, e Lenis scorre la pagina come altrove.
     data-lenis-prevent sulla fila darebbe al browser anche il verticale, che scorrerebbe la pagina senza Lenis.
   - Indice e ingrandimento sono pannelli del foglio 07: zgScrollLock (luxury.js: ferma Lenis e la pagina), data-lenis-prevent
     sul contenitore che scorre, zgFocusTrap, Esc chiude e il fuoco torna dov'era.
   - L'ingrandimento e' codice nostro e non PhotoSwipe 5: una pagina sola alla volta, un'immagine, tre livelli (1x, 2x, 3x,
     e in mezzo con due dita o col pizzico del trackpad), trascinamento, frecce, Esc. La sua parte di questo file e' 7,4 KB,
     2,6 KB compressi (gzip -9, misurata da sola); PhotoSwipe non l'abbiamo scaricato ne' misurato: porterebbe un file di
     terzi da tenere aggiornato negli asset (CLAUDE.md, regola 3: niente librerie esterne) e un suo blocco dello scorrimento
     da mettere d'accordo con Lenis e zgScrollLock. */
(function () {
  'use strict';
  var lento = window.matchMedia('(prefers-reduced-motion: reduce)');
  var computer = window.matchMedia('(min-width: 1024px)');
  var arr = function (x) { return Array.prototype.slice.call(x); };

  function avvia(R) {
    if (!R || R.zgCv) return;
    R.zgCv = true;
    var fila = R.querySelector('[data-cv-fila]'), tavolo = R.querySelector('[data-cv-tavolo]');
    var fogli = arr(fila.querySelectorAll('.zg-cv__foglio')), pagine = arr(fila.querySelectorAll('.zg-cv__pagina'));
    if (!pagine.length) return;
    var prec = R.querySelector('[data-cv-prec]'), succ = R.querySelector('[data-cv-succ]');
    var conte = arr(R.querySelectorAll('[data-cv-conta]'));
    var tP = R.getAttribute('data-t-pagina'), tD = R.getAttribute('data-t-doppia');
    var modo = computer.matches, cur = 0, pag = 1, bersaglio = -1, mosso = false, pronto = false, quiete = 0, raf = 0;

    function unita() { return modo ? fogli : pagine; }
    function num(el) { return +el.getAttribute('data-p'); }
    function estremi(u) {
      var p = u.classList.contains('zg-cv__pagina') ? [u] : u.querySelectorAll('.zg-cv__pagina');
      return [num(p[0]), num(p[p.length - 1])];
    }
    /* l'unita' della pagina stampata n; se il file di n manca, la prima dopo */
    function unitaDi(n) {
      var u = unita();
      for (var i = 0; i < u.length; i++) if (estremi(u[i])[1] >= n) return i;
      return u.length - 1;
    }
    function inVista() {
      var w = fila.clientWidth || 1;
      return Math.max(0, Math.min(unita().length - 1, Math.round(fila.scrollLeft / w)));
    }
    function leggiHash() { var m = /^#p(\d{1,4})$/.exec(location.hash); return m ? +m[1] : 0; }

    function carica(u) {
      if (!u) return;
      arr(u.querySelectorAll('img[data-srcset]')).forEach(function (im) {
        im.srcset = im.getAttribute('data-srcset');
        im.src = im.getAttribute('data-src');
        im.removeAttribute('data-srcset');
        im.removeAttribute('data-src');
      });
    }
    function vicine() { var u = unita(); carica(u[cur]); carica(u[cur - 1]); carica(u[cur + 1]); }
    function parti() { if (!pronto) { pronto = true; vicine(); } }

    function segna(i) {
      var u = unita(), e = estremi(u[i]);
      cur = i;
      if (pag < e[0] || pag > e[1]) pag = e[0];
      var t = e[0] === e[1] ? tP.replace('%1', e[0]) : tD.replace('%1', e[0]).replace('%2', e[1]);
      conte.forEach(function (c) { if (c.textContent !== t) c.textContent = t; });
      prec.setAttribute('aria-disabled', i <= 0 ? 'true' : 'false');
      succ.setAttribute('aria-disabled', i >= u.length - 1 ? 'true' : 'false');
      if (pronto) vicine();
      segnaIndice(e[0]);
    }
    function indirizzo() {
      var e = estremi(unita()[cur]), h = leggiHash();
      if (h >= e[0] && h <= e[1]) return;
      try { history.replaceState(history.state, '', location.pathname + location.search + '#p' + e[0]); } catch (err) {}
    }
    function fermo() {
      clearTimeout(quiete);
      quiete = setTimeout(function () {
        bersaglio = -1;
        var j = inVista();
        if (j !== cur) segna(j);
        if (mosso) indirizzo();
      }, 200);
    }
    function vai(i, liscio, utente) {
      var u = unita();
      i = Math.max(0, Math.min(u.length - 1, i));
      var x = u[i].offsetLeft;
      if (utente) mosso = true;
      bersaglio = Math.abs(fila.scrollLeft - x) < 1 ? -1 : i;
      try { fila.scrollTo({ left: x, behavior: liscio && !lento.matches ? 'smooth' : 'instant' }); }
      catch (err) { fila.scrollLeft = x; }
      segna(i);
      fermo();
    }
    function portaInVista() {
      var h = document.querySelector('.site-header'), alto = h ? Math.max(0, h.getBoundingClientRect().bottom) : 0;
      /* Natale (foglio di Giacomo del 18/10, pubblicazione 2): con le luminarie il tavolo arriva sotto di loro, non sotto la
         testata. Pendono 53 px sotto il bordo della testata dai 768, 39 sotto (luxury.css, «NATALE, RITOCCHI FINALI»), piu' 1 px
         perche' lo scorrimento qui sotto si arrotonda al px (sul banco con 39 il tavolo restava 0,28 px dentro). La classe c'e' dal
         primo disegno, il canvas arriva dopo il caricamento */
      if (alto && document.documentElement.classList.contains('zg-natale-lum')) alto += window.innerWidth < 768 ? 40 : 54;
      var y = Math.max(0, Math.round(window.pageYOffset + tavolo.getBoundingClientRect().top - alto));
      var l = window.ZAGARA && window.ZAGARA.lenis;
      if (l) l.scrollTo(y, { immediate: true, force: true }); else window.scrollTo(0, y);
    }

    fila.addEventListener('scroll', function () {
      if (!raf) raf = requestAnimationFrame(function () {
        raf = 0;
        var j = inVista();
        if (bersaglio >= 0) { if (j !== bersaglio) return; bersaglio = -1; }
        if (j !== cur) { mosso = true; segna(j); }
      });
      fermo();
    }, { passive: true });

    /* la rotella con Lenis: l'asse si decide al primo evento del gesto (sopra, nell'intestazione) */
    var asse = '', tAsse = -1e9;
    fila.addEventListener('wheel', function (e) {
      if (e.ctrlKey) return;
      /* revisione R3: un evento nettamente dell'altro asse (il doppio e almeno 4 px) cambia l'asse anche senza la pausa: un
         gesto di lato cominciato mentre arriva ancora lo slancio di uno verticale andava tutto a Lenis (la fila ferma) */
      var ax = Math.abs(e.deltaX), ay = Math.abs(e.deltaY), lato = (e.shiftKey && !e.deltaX) || (ax >= 2 * ay && ax >= 4), su = !e.shiftKey && ay >= 2 * ax && ay >= 4;
      if (e.timeStamp - tAsse > 200) asse = ax > ay || (e.shiftKey && !e.deltaX) ? 'x' : 'y';
      else if (asse === 'y' ? lato : su) asse = lato ? 'x' : 'y';
      tAsse = e.timeStamp;
      if (asse === 'x') e.stopPropagation();
    }, { passive: true });

    tavolo.addEventListener('keydown', function (e) {
      if (e.altKey || e.ctrlKey || e.metaKey || e.defaultPrevented) return;
      var k = e.key, i;
      if (k === 'ArrowLeft') i = cur - 1;
      else if (k === 'ArrowRight') i = cur + 1;
      else if (k === 'Home') i = 0;
      else if (k === 'End') i = unita().length - 1;
      else return;
      e.preventDefault();
      vai(i, k === 'ArrowLeft' || k === 'ArrowRight', true);
    });
    prec.addEventListener('click', function () { if (cur > 0) vai(cur - 1, true, true); });
    succ.addEventListener('click', function () { if (cur < unita().length - 1) vai(cur + 1, true, true); });

    /* la larghezza cambia (finestra, rotazione, passaggio dei 1024): la stessa pagina resta in vista */
    function allinea() {
      if (computer.matches !== modo) { modo = computer.matches; segna(unitaDi(pag)); }
      var x = unita()[cur].offsetLeft;
      if (Math.abs(fila.scrollLeft - x) > 1) { bersaglio = cur; fila.scrollLeft = x; fermo(); }
    }
    if (window.ResizeObserver) new ResizeObserver(allinea).observe(fila);
    else window.addEventListener('resize', allinea);

    window.addEventListener('hashchange', function () {
      var n = leggiHash();
      if (!n) return;
      pag = n;
      vai(unitaDi(n), false, false);
      portaInVista();
      parti();
    });

    /* ── i pannelli ── */
    function apri(P) {
      P.hidden = false;
      void P.offsetWidth;
      P.classList.add('is-open');
      if (window.zgScrollLock) window.zgScrollLock.on();
      if (window.zgFocusTrap) window.zgFocusTrap.on(P);
    }
    function chiudi(P, torna) {
      P.classList.remove('is-open');
      if (window.zgFocusTrap) window.zgFocusTrap.off(P);
      if (window.zgScrollLock) window.zgScrollLock.off();
      setTimeout(function () { if (!P.classList.contains('is-open')) P.hidden = true; }, lento.matches ? 0 : 320);
      var f = torna && torna !== document.body && document.contains(torna) ? torna : fila;
      try { f.focus({ preventScroll: true }); } catch (err) { f.focus(); }
    }

    /* l'indice */
    var I = R.querySelector('[data-cv-indice]'), apriI = R.querySelector('[data-cv-apri-indice]');
    var voci = arr(I.querySelectorAll('a[data-p]')), indiceDa = null;
    function segnaIndice(n) {
      var s = -1;
      voci.forEach(function (a, k) { if (num(a) <= n) s = k; });
      voci.forEach(function (a, k) { if (k === s) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current'); });
    }
    apriI.addEventListener('click', function () {
      indiceDa = document.activeElement;
      apri(I);
      var a = I.querySelector('a[aria-current="true"]') || I.querySelector('.zg-cv-chiudi');
      try { a.focus({ preventScroll: true }); } catch (err) { a.focus(); }
      /* la voce corrente a meta' dell'elenco: scrollTop dell'elenco e basta (scrollIntoView muoverebbe anche la pagina) */
      var el = I.querySelector('.zg-cv-indice__elenco');
      if (el && a.closest('.zg-cv-indice__elenco')) el.scrollTop = Math.max(0, a.offsetTop - (el.clientHeight - a.offsetHeight) / 2);
    });
    I.addEventListener('click', function (e) {
      var a = e.target.closest('a[data-p]');
      if (a) {
        e.preventDefault();
        chiudi(I, indiceDa);
        pag = num(a);
        vai(unitaDi(pag), false, true);
        parti();
      } else if (e.target.closest('[data-cv-chiudi]')) chiudi(I, indiceDa);
    });
    I.addEventListener('keydown', function (e) { if (e.key === 'Escape') { e.preventDefault(); chiudi(I, indiceDa); } });

    /* l'ingrandimento */
    var Z = R.querySelector('[data-cv-zoom]'), palco = Z.querySelector('[data-cv-palco]'), zimg = Z.querySelector('[data-cv-zimg]');
    var znum = Z.querySelector('[data-cv-znum]'), zprec = Z.querySelector('[data-cv-zprec]'), zsucc = Z.querySelector('[data-cv-zsucc]');
    var livelli = arr(Z.querySelectorAll('[data-cv-livello]')), apriZ = R.querySelector('[data-cv-apri-zoom]');
    var zN = 1, zDa = null, zS = 1, zX = 0, zY = 0, zA = 1800 / 2550, fw = 0, fh = 0, W = 0, H = 0, SU = 56, GIU = 16;
    function figDi(n) {
      for (var k = 0; k < pagine.length; k++) if (num(pagine[k]) >= n) return pagine[k];
      return pagine[pagine.length - 1];
    }
    function misura() {
      W = palco.clientWidth; H = palco.clientHeight;
      var m = W < 768 ? 8 : 64;
      fw = Math.max(1, Math.min(W - 2 * m, (H - SU - GIU) * zA)); fh = fw / zA;
      zimg.style.width = fw + 'px'; zimg.style.height = fh + 'px';
    }
    function applica(anim) {
      var w = fw * zS, h = fh * zS;
      zX = w <= W ? (W - w) / 2 : Math.min(0, Math.max(W - w, zX));
      zY = h <= H - SU - GIU ? SU + (H - SU - GIU - h) / 2 : Math.min(0, Math.max(H - h, zY));
      zimg.style.transition = anim && !lento.matches ? 'transform .25s cubic-bezier(.16, 1, .3, 1)' : 'none';
      zimg.style.transform = 'translate(' + zX + 'px, ' + zY + 'px) scale(' + zS + ')';
      Z.classList.toggle('is-zoomed', zS > 1.01);
      livelli.forEach(function (b) { b.setAttribute('aria-pressed', Math.abs(zS - b.getAttribute('data-cv-livello')) < .05 ? 'true' : 'false'); });
    }
    function scala(s, px, py, anim) {
      s = Math.max(1, Math.min(3, s));
      if (px == null) { px = W / 2; py = H / 2; }
      zX = px - (px - zX) * s / zS; zY = py - (py - zY) * s / zS; zS = s;
      applica(anim);
    }
    /* revisione R4: la grande (1800 px) e' una sola, quella della pagina in vista. Passando le pagine la precedente si interrompe
       e la nuova parte dopo 250 ms fermi (all'apertura subito): prima ogni pagina passata scaricava la sua (8 pagine al
       telefono: 3 MB, e la grande dell'ultima dopo 17 s) */
    var pre = null, preT = 0;
    function grande(url, n, subito) {
      clearTimeout(preT);
      if (pre) { pre.onload = null; pre.src = ''; pre = null; }
      if (!url) return;
      preT = setTimeout(function () {
        var g = pre = new Image();
        g.onload = function () { if (pre === g && zN === n) zimg.src = url; };
        g.src = url;
      }, subito ? 0 : 250);
    }
    function mostra(fig, subito) {
      var im = fig.querySelector('img'), n = num(fig), k = pagine.indexOf(fig);
      zN = n;
      zA = (+im.getAttribute('width') || 1800) / (+im.getAttribute('height') || 2550);
      zimg.alt = im.alt;
      /* subito la pagina piccola: quella gia' arrivata nella fila, se no la misura piu' piccola del srcset (360), non la 900 */
      zimg.src = im.complete && im.currentSrc ? im.currentSrc : (im.getAttribute('data-srcset') || im.getAttribute('srcset') || im.getAttribute('data-src') || im.src).split(' ')[0];
      grande(fig.getAttribute('data-zoom'), n, subito);
      znum.textContent = tP.replace('%1', n);
      zprec.setAttribute('aria-disabled', k <= 0 ? 'true' : 'false');
      zsucc.setAttribute('aria-disabled', k >= pagine.length - 1 ? 'true' : 'false');
      zS = 1; misura(); applica(false);
    }
    function passo(d) { var k = pagine.indexOf(figDi(zN)) + d; if (k >= 0 && k < pagine.length) mostra(pagine[k], false); }
    function apriZoom(n, da) {
      zDa = da || document.activeElement;
      apri(Z);
      mostra(figDi(n), true);
      var c = Z.querySelector('.zg-cv-chiudi');
      try { c.focus({ preventScroll: true }); } catch (err) { c.focus(); }
    }
    function chiudiZoom() {
      grande(null);
      chiudi(Z, zDa);
      pag = zN;
      var i = unitaDi(zN);
      if (i !== cur) vai(i, false, true);
    }
    fila.addEventListener('click', function (e) { var f = e.target.closest('.zg-cv__pagina'); if (f) apriZoom(num(f), null); });
    apriZ.addEventListener('click', function () { apriZoom(estremi(unita()[cur])[0], apriZ); });
    Z.addEventListener('click', function (e) {
      var b = e.target.closest('button');
      if (!b || b.getAttribute('aria-disabled') === 'true') return;
      if (b.hasAttribute('data-cv-chiudi')) chiudiZoom();
      else if (b === zprec) passo(-1);
      else if (b === zsucc) passo(1);
      else if (b.hasAttribute('data-cv-livello')) scala(+b.getAttribute('data-cv-livello'), null, null, true);
    });
    Z.addEventListener('keydown', function (e) {
      var k = e.key;
      if (k === 'Escape') chiudiZoom();
      else if (k === 'ArrowLeft' || k === 'ArrowRight') passo(k === 'ArrowRight' ? 1 : -1);
      else if (k === '+' || k === '=') scala(Math.min(3, Math.floor(zS + 1.0001)), null, null, true);
      else if (k === '-' || k === '_') scala(Math.max(1, Math.ceil(zS - 1.0001)), null, null, true);
      else if (k === '0') scala(1, null, null, true);
      else if ((k === 'ArrowUp' || k === 'ArrowDown') && zS > 1.01) { zY += k === 'ArrowUp' ? 80 : -80; applica(true); }
      else return;
      e.preventDefault();
    });
    palco.addEventListener('wheel', function (e) {
      e.preventDefault();
      var f = e.deltaMode === 1 ? 16 : 1;
      if (e.ctrlKey) scala(zS * Math.exp(-e.deltaY * f * 0.01), e.clientX, e.clientY, false);
      else if (zS > 1.01) { zX -= e.deltaX * f; zY -= e.deltaY * f; applica(false); }
    }, { passive: false });
    /* il dito e il mouse: uno trascina (ingrandita) o passa pagina (intera, gesto di lato oltre 50 px); due ingrandiscono
       attorno al loro punto medio; un tocco doppio passa da 1x a 2x e torna; col mouse un clic sale di un livello (3x -> 1x) */
    var punti = {}, g = null, tap = 0, tapXY = null;
    function inizio(e) {
      var ids = Object.keys(punti), a = punti[ids[0]], b = punti[ids[1]];
      if (ids.length === 1) g = { n: 1, x0: a.x, y0: a.y, zx: zX, zy: zY, mosso: false, tipo: e.pointerType };
      else if (ids.length > 1) g = { n: 2, d0: Math.hypot(a.x - b.x, a.y - b.y) || 1, s0: zS, cx: (a.x + b.x) / 2, cy: (a.y + b.y) / 2, zx: zX, zy: zY };
    }
    palco.addEventListener('pointerdown', function (e) {
      if (e.button > 0) return;
      try { palco.setPointerCapture(e.pointerId); } catch (err) {}
      punti[e.pointerId] = { x: e.clientX, y: e.clientY };
      inizio(e);
    });
    palco.addEventListener('pointermove', function (e) {
      if (!punti[e.pointerId] || !g) return;
      punti[e.pointerId] = { x: e.clientX, y: e.clientY };
      if (g.n === 1) {
        var dx = e.clientX - g.x0, dy = e.clientY - g.y0;
        if (!g.mosso && Math.abs(dx) + Math.abs(dy) > 6) { g.mosso = true; Z.classList.add('is-trascina'); }
        if (g.mosso && zS > 1.01) { zX = g.zx + dx; zY = g.zy + dy; applica(false); }
      } else {
        var ids = Object.keys(punti), a = punti[ids[0]], b = punti[ids[1]];
        var s = Math.max(1, Math.min(3, g.s0 * Math.hypot(a.x - b.x, a.y - b.y) / g.d0));
        zX = (a.x + b.x) / 2 - (g.cx - g.zx) * s / g.s0; zY = (a.y + b.y) / 2 - (g.cy - g.zy) * s / g.s0; zS = s;
        applica(false);
      }
    });
    function fine(e) {
      if (!punti[e.pointerId]) return;
      delete punti[e.pointerId];
      Z.classList.remove('is-trascina');
      var resto = Object.keys(punti).length, h = g;
      g = null;
      if (!h) return;
      if (h.n === 2) {
        if (zS < 1.05) { zS = 1; applica(true); }
        if (resto) inizio(e);
        return;
      }
      if (e.type === 'pointercancel') return;
      var dx = e.clientX - h.x0, dy = e.clientY - h.y0;
      if (!h.mosso) {
        if (h.tipo === 'mouse') scala(zS < 1.5 ? 2 : zS < 2.5 ? 3 : 1, e.clientX, e.clientY, true);
        else if (e.timeStamp - tap < 320 && tapXY && Math.hypot(e.clientX - tapXY.x, e.clientY - tapXY.y) < 30) { scala(zS > 1.01 ? 1 : 2, e.clientX, e.clientY, true); tap = 0; }
        else { tap = e.timeStamp; tapXY = { x: e.clientX, y: e.clientY }; }
      } else if (zS <= 1.01 && Math.abs(dx) > 50 && Math.abs(dx) > 1.5 * Math.abs(dy)) passo(dx < 0 ? 1 : -1);
    }
    palco.addEventListener('pointerup', fine);
    palco.addEventListener('pointercancel', fine);
    window.addEventListener('resize', function () { if (!Z.hidden) { misura(); applica(false); } });

    /* revisione R2: un clic del mouse su una parte del pannello che non prende il fuoco (l'immagine ingrandita, il titolo
       dell'indice) lo portava a <main tabindex="-1">, fuori dal pannello: Esc, le frecce e il Tab chiuso non andavano piu' */
    function tieniFuoco(e) { if (!e.target.closest('a[href], button, input, select, textarea')) e.preventDefault(); }
    Z.addEventListener('mousedown', tieniFuoco);
    I.querySelector('.zg-cv-indice__pannello').addEventListener('mousedown', tieniFuoco);

    /* l'avvio: #pNN, oppure la posizione che il browser ha ripristinato */
    var h0 = leggiHash();
    if (h0) {
      pag = h0;
      cur = unitaDi(h0);
      bersaglio = cur;
      fila.scrollLeft = unita()[cur].offsetLeft;
    } else cur = inVista();
    segna(cur);
    if (h0) { portaInVista(); parti(); }
    else {
      var cop = fila.querySelector('img[fetchpriority="high"]');
      if (!cop || cop.complete) parti();
      else { cop.addEventListener('load', parti); cop.addEventListener('error', parti); setTimeout(parti, 3000); }
    }
  }

  arr(document.querySelectorAll('[data-zg-cv]')).forEach(avvia);
  document.addEventListener('shopify:section:load', function (e) { avvia(e.target.querySelector('[data-zg-cv]')); });
})();
